<mat-dialog-content>
  <div class="message" [innerHTML]='safeHtml'></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close (click)="onCancel()" class="cancel-btn">キャンセル</button>
  <button mat-raised-button (click)="onOK()" class="yes-btn">OK</button>
</mat-dialog-actions>
